import React from 'react';
import logo from './logo.svg';
import './App.css';
import WalmartSupplyChainSimulation from './WalmartSupplyChainSimulation.jsx';

function App() {
  return (
    <div className="App">
      <WalmartSupplyChainSimulation />
    </div>
  );
}

export default App;

